import React from "react";
import { connect } from "react-redux";
import VendorContent from "containers/request/RequestContent/VendorContent";
import reqTypes from "dictionaries/ReqTypes";
import { batteryTabsBSC, batteryTabsEcoBSC } from "helpers/RequestTabsHelper";
import {
  getChecklistInitialBSC,
  getChecklistEcoBSC
} from "helpers/ChecklistBatteryHelper";

const RequestContentBSC = ({ request, focusLab }) => {
  const checkListInitial = getChecklistInitialBSC(request);
  const checkListECO = getChecklistEcoBSC(request);

  switch (request.type) {
    case reqTypes.initial:
      return (
        <VendorContent
          tabs={batteryTabsBSC}
          checkList={checkListInitial}
          defaultTab={focusLab ? "labInfo" : "deviceInfo"}
        />
      );
    case reqTypes.eco:
      return (
        <VendorContent
          tabs={batteryTabsEcoBSC}
          checkList={checkListECO}
          defaultTab={focusLab ? "labInfo" : "deviceInfo"}
        />
      );
    default:
      return null;
  }
};

function mapStateToProps({ request }) {
  return { request };
}

export default connect(mapStateToProps)(RequestContentBSC);
